import { render, staticRenderFns } from "./Plugin.vue?vue&type=template&id=5dfed454&"
import script from "./Plugin.vue?vue&type=script&lang=js&"
export * from "./Plugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dfed454')) {
      api.createRecord('5dfed454', component.options)
    } else {
      api.reload('5dfed454', component.options)
    }
    module.hot.accept("./Plugin.vue?vue&type=template&id=5dfed454&", function () {
      api.rerender('5dfed454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Components/UsbTokens/Plugin.vue"
export default component.exports